import { convertListToObj, getTechDisplayLabel } from "@utils/appUtils";

import {
  LICENSE_FEATURES_DISPLAY_LABEL,
  LICENSE_FEATURES_PERMISSION,
  USER_ROLES_CONFIG,
} from "../constants/UserSettings.constants";

export const getUserProductPermissionsSet = userPermissions => {
  const permissionsSet = new Set(userPermissions?.Product);

  const hasExperimentalElementFeature = userPermissions?.Feature?.includes(
    LICENSE_FEATURES_PERMISSION.EXPERIMENTAL_ELEMENT,
  );
  if (hasExperimentalElementFeature) {
    permissionsSet.add(LICENSE_FEATURES_PERMISSION.EXPERIMENTAL_ELEMENT);
  }

  return permissionsSet;
};

export const isElementLicensedForPermissions = (element, userProductPermissionsSet) =>
  element?.lstProductCategory?.some(productCategory => userProductPermissionsSet?.has(productCategory));

export const getLicensedProducts = (productsList, userPermissions) => {
  const userProductPermissionsSet = getUserProductPermissionsSet(userPermissions);
  return productsList?.filter(product => isElementLicensedForPermissions(product, userProductPermissionsSet)) || [];
};

/**
 * Groups license permissions by category
 * @param {Array} licensePermissions - Array of license permission objects
 * @returns {Object} Grouped permissions object with categories as keys
 */
export const groupLicensePermissionsByCategory = (licensePermissions = []) =>
  licensePermissions.reduce((acc, curr) => {
    const { name, category } = curr || {};
    if (!acc[category]) acc[category] = [];
    const mappedDisplayName = LICENSE_FEATURES_DISPLAY_LABEL[name] ?? name;
    const displayName = category === "Technology" ? getTechDisplayLabel(name) : mappedDisplayName;
    acc[category].push({ ...curr, name: displayName });
    return acc;
  }, {});

const ROLE_CONFIG_BY_NAME = convertListToObj(USER_ROLES_CONFIG, "name");

const hasRoleAccess = (roles, accessKey) => {
  if (!Array.isArray(roles)) return false;
  return roles.some(role => ROLE_CONFIG_BY_NAME[role.name]?.[accessKey]);
};

/** Checks if user has license management access */
export const hasLicenseManagementAccess = roles => hasRoleAccess(roles, "isLicenseManagement");

/** Checks if user has warranty management access */
export const hasWarrantyManagementAccess = roles => hasRoleAccess(roles, "isWarrantyManagement");
